import { Checkbox } from "@chakra-ui/checkbox";
import { Box } from "@chakra-ui/layout";
import colors from "core/resources/theme/colors";
import OutlineButton from "ui/components/Button/OutlineButton";
import PrimaryButton from "ui/components/Button/PrimaryButton";

interface FooterModalProps {
  onSubmit?: () => any;
  isDisabled?: boolean;
  isLoadingSave?: boolean;
  registerAnother?: boolean;
  onClose?: () => any;
  setRegisterAnother?: (v: boolean) => void;
  showRegisterAnother?: boolean;
  primaryButtonText?: string;
  buttonCancelarText?: string;
  primaryButtonBgColor?: string;
  filtroValue?: number;
  hidePrimaryButton?: boolean;
  primaryButtonHtmlTitle?: string;
  right?: any;
  showBorderTop?: boolean;
  secondaryButtonText?: string;
  onSecondaryClick?: () => any;
  secondaryButtonDisabled?: boolean;
  secondaryButtonHtmlTitle?: string;
}

function FooterModal({
  isLoadingSave,
  isDisabled,
  registerAnother = true,
  setRegisterAnother,
  onSubmit,
  onClose,
  showRegisterAnother = true,
  primaryButtonText = "Salvar",
  buttonCancelarText = "Cancelar",
  primaryButtonBgColor = colors.primary,
  filtroValue,
  hidePrimaryButton = false,
  primaryButtonHtmlTitle,
  right,
  showBorderTop = true,
  secondaryButtonText,
  onSecondaryClick,
  secondaryButtonDisabled,
  secondaryButtonHtmlTitle,
}: FooterModalProps) {
  return (
    <Box
      pt="32px"
      borderTop={showBorderTop ? "1px solid #efefef" : ""}
      justifyContent="flex-end"
      d="flex"
      gridGap="8px"
      flexDir="row"
      alignItems="center"
    >
      {right}

      {showRegisterAnother ? (
        <Checkbox
          mr="auto"
          isChecked={registerAnother}
          onChange={() => setRegisterAnother?.(!registerAnother)}
        >
          Cadastrar outra após salvar
        </Checkbox>
      ) : null}

      {typeof onClose === "function" ? (
        <OutlineButton type="button" onClick={onClose} minWidth="120px">
          {buttonCancelarText || "Cancelar"}
        </OutlineButton>
      ) : null}

      {typeof onSecondaryClick === "function" ? (
        <OutlineButton
          type="button"
          onClick={onSecondaryClick}
          minWidth="120px"
          isDisabled={secondaryButtonDisabled}
          title={secondaryButtonHtmlTitle}
        >
          {secondaryButtonText}
        </OutlineButton>
      ) : null}

      {!hidePrimaryButton && typeof onSubmit === "function" ? (
        <PrimaryButton
          type="button"
          title={primaryButtonHtmlTitle}
          isLoading={isLoadingSave}
          onClick={onSubmit}
          minWidth={"120px"}
          isDisabled={isDisabled || isLoadingSave}
          cursor={isDisabled || isLoadingSave ? "not-allowed" : undefined}
          bgColor={primaryButtonBgColor}
        >
          {primaryButtonText}
          {typeof filtroValue === "number" && filtroValue > 0
            ? `(${filtroValue})`
            : null}
        </PrimaryButton>
      ) : null}
    </Box>
  );
}

export default FooterModal;
